import { FaCheckCircle, FaMapMarkerAlt, FaIndustry, FaAward } from 'react-icons/fa';
import SectionTitle from './ui/SectionTitle';
import Button from './ui/Button';
import './About.css';

const HIGHLIGHTS = [
  "Sialkot, Pakistan — World's Surgical Hub",
  'State-of-the-art manufacturing facility',
  'Strict quality control at every stage',
  'Custom OEM & private label available',
  'On-time delivery guarantee',
  'Competitive factory-direct pricing',
];

const CARDS = [
  { icon: <FaIndustry />,    label: 'Manufacturing Excellence', cls: 'about__card--main' },
  { icon: <FaAward />,       label: 'Quality Assured',          cls: 'about__card--top' },
  { icon: <FaMapMarkerAlt />, label: 'Sialkot, Pakistan',       cls: 'about__card--bot', red: true },
];

export default function About() {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about__grid">

          <div className="about__visual" aria-hidden="true">
            <div className="about__circle" />
            {CARDS.map(c => (
              <div key={c.label} className={`about__card ${c.cls}`}>
                <span className={c.red ? 'about__card-icon--red' : ''}>{c.icon}</span>
                <p>{c.label}</p>
              </div>
            ))}
          </div>

          <div className="about__body">
            <SectionTitle
              title="About H.A Surgical"
              align="left"
            />

            <p className="about__intro">
              H.A Surgical is a leading manufacturer and exporter of premium surgical
              and medical instruments, proudly based in Sialkot — Pakistan's globally
              renowned surgical instruments capital.
            </p>

            <p className="about__text">
              With over <strong>25 years of expertise</strong>, we combine traditional
              craftsmanship with modern precision engineering to produce instruments
              that meet the highest international standards. Our products are trusted
              by medical professionals and distributors in over 40 countries worldwide.
            </p>

            <ul className="about__list">
              {HIGHLIGHTS.map(item => (
                <li key={item}>
                  <FaCheckCircle className="about__check" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <Button href="/catalogs/complete" variant="primary" className="about__cta">
              View Complete Catalog
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
